import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TIndexTypeCategory {
  id: number;
  code: string;
  name: string;
  valid: boolean;
  description: string;
  connected: boolean;
}

export interface IIndexTypeCategory extends TIndexTypeCategory {}

const IndexTypeCategory = Model(
  (model: TIndexTypeCategory): IIndexTypeCategory => {
    const _value: TIndexTypeCategory = Object.assign({}, model);

    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get code() {
        return _value.code;
      },
      set code(value) {
        _value.code = value;
      },

      get name() {
        return _value.name;
      },
      set name(value) {
        _value.name = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      },
      get description() {
        return _value.description;
      },
      set description(value) {
        _value.description = value;
      },
      get connected() {
        return _value.connected;
      },
      set connected(value) {
        _value.connected = value;
      }
    };

    return ValidatableObject<IIndexTypeCategory>(_model);
  }
);

export default IndexTypeCategory;
